import React from 'react';
import type { FormItemConfig } from '@ms/shared-components/comps/CompsForm';
import JsonEditor from '../../../components/JsonEditor';
import TagInput from '../../../components/TagInput';

const formatTypeOptions = [
  { label: 'Markdown', value: 'markdown' },
  { label: 'JSON', value: 'json' },
  { label: '文本', value: 'text' },
  { label: '表格', value: 'table' },
  { label: '列表', value: 'list' },
];

export const getFormItems = (): FormItemConfig[] => [
  {
    name: 'formatId',
    label: '返回格式ID',
    type: 'input',
    rules: [{ required: true, message: '请输入返回格式ID' }],
    props: { placeholder: '例如：markdown-standard, json-simple' },
  },
  {
    name: 'formatType',
    label: '格式类型',
    type: 'select',
    rules: [{ required: true, message: '请选择格式类型' }],
    options: formatTypeOptions,
  },
  {
    name: 'description',
    label: '描述',
    type: 'textarea',
    props: { rows: 3 },
  },
  {
    name: 'schema',
    label: 'JSON Schema',
    type: 'custom',
    customComponent: JsonEditor,
    props: { 
      placeholder: '输入 JSON Schema，例如：{"type": "object", "properties": {...}}',
      rows: 6,
    },
  },
  {
    name: 'template',
    label: '模板',
    type: 'textarea',
    props: { 
      rows: 6,
      placeholder: '用于 Markdown/Text 格式，支持变量：{title}, {content}',
    },
  },
  {
    name: 'requirements',
    label: '结果内容要求',
    type: 'textarea',
    props: { 
      rows: 4,
      placeholder: '例如：必须包含：1. 数据概览 2. 关键发现 3. 趋势分析',
    },
  },
  {
    name: 'constraints',
    label: '约束条件 (JSON)',
    type: 'custom',
    customComponent: JsonEditor,
    props: { 
      placeholder: '输入 JSON 格式，例如：{"maxLength": 2000, "minLength": 100}',
      rows: 4,
    },
  },
  {
    name: 'maxLength',
    label: '最大长度（字符数）',
    type: 'number',
    props: { style: { width: '100%' }, min: 0 },
  },
  {
    name: 'positiveWords',
    label: '正面词',
    type: 'custom',
    customComponent: TagInput,
    props: { placeholder: '输入正面词，按回车添加' },
  },
  {
    name: 'negativeWords',
    label: '负面词',
    type: 'custom',
    customComponent: TagInput,
    props: { placeholder: '输入负面词，按回车添加' },
  },
  {
    name: 'isActive',
    label: '是否启用',
    type: 'switch',
    valuePropName: 'checked',
    props: { checkedChildren: '启用', unCheckedChildren: '禁用' },
  },
];

export const formConfig = {
  layout: 'horizontal' as const,
  contentPadding: 0,
};
